import React from 'react';
import { useDispatch } from 'react-redux';
import { TourProvider } from '@reactour/tour';
import { steps, nextButton } from './tourActions/tourActions';
import { getTourSteps, useTourModalStyles } from './pageTour/pageTour';
import { setRelaunchTooltip, setShowTour } from '../../redux/RelaunchSlice/RelaunchSlice';
import { toggleSubMenus } from '../../redux/SubMenuToggleSlice/SubMenuToggleSlice';
import { walkThroughSavePage } from './tourActions/tourActions';

const WalkThrough = ({ children }) => {
    const dispatch = useDispatch();
    const tourModalstyles = useTourModalStyles();

    return (
        <TourProvider
            steps={getTourSteps}
            showDots={false}
            prevButton={steps}
            nextButton={nextButton}
            styles={tourModalstyles}
            scrollSmooth
            disableWhenSelectorFalsy={true}
            padding={{ popover: 15 }}
            onClickMask={() => {
            }}
            onClickClose={({ setIsOpen }) => {
                dispatch(setShowTour({showTour: false}))
                dispatch(toggleSubMenus({ title: 'support' }));
                dispatch(setRelaunchTooltip({openRelaunchTooltip: true}))
                setIsOpen(false)
                walkThroughSavePage()
              }}
        >
            {children}
        </TourProvider>
    );
};

export default WalkThrough;
